import { render, staticRenderFns } from "./alquileres.vue?vue&type=template&id=f226d442&scoped=true&"
import script from "./alquileres.vue?vue&type=script&lang=js&"
export * from "./alquileres.vue?vue&type=script&lang=js&"
import style0 from "./alquileres.vue?vue&type=style&index=0&id=f226d442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f226d442",
  null
  
)

export default component.exports